var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11C6.10312 11 7 10.1031 7 9C7 7.89688 6.10312 7 5 7C3.89688 7 3 7.89688 3 9C3 10.1031 3.89688 11 5 11ZM19 11C20.1031 11 21 10.1031 21 9C21 7.89688 20.1031 7 19 7C17.8969 7 17 7.89688 17 9C17 10.1031 17.8969 11 19 11ZM20 12H18C17.45 12 16.9531 12.2219 16.5906 12.5813C17.85 13.2719 18.7438 14.5187 18.9375 16H21C21.5531 16 22 15.5531 22 15V14C22 12.8969 21.1031 12 20 12ZM12 12C13.9344 12 15.5 10.4344 15.5 8.5C15.5 6.56562 13.9344 5 12 5C10.0656 5 8.5 6.56562 8.5 8.5C8.5 10.4344 10.0656 12 12 12ZM14.4 13H14.1406C13.4906 13.3125 12.7688 13.5 12 13.5C11.2312 13.5 10.5125 13.3125 9.85938 13H9.6C7.6125 13 6 14.6125 6 16.6V17.5C6 18.3281 6.67188 19 7.5 19H16.5C17.3281 19 18 18.3281 18 17.5V16.6C18 14.6125 16.3875 13 14.4 13ZM7.40938 12.5813C7.04688 12.2219 6.55 12 6 12H4C2.89688 12 2 12.8969 2 14V15C2 15.5531 2.44687 16 3 16H5.05938C5.25625 14.5187 6.15 13.2719 7.40938 12.5813Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.2d7a18961952cc4f75b02d28ba3d24bc.svg";
export { ForwardRef as ReactComponent };